// extracted by mini-css-extract-plugin
module.exports = {"banner-root":"BannerEcommerce_banner-root__3Aoh0","mobile":"BannerEcommerce_mobile__C8pOu","desktop":"BannerEcommerce_desktop__eOnSr"};